import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { IncludesSection } from './components/IncludesSection';
import { ImageCarousel } from './components/ImageCarousel';
import { BonusSection } from './components/BonusSection';
import { AuthoritySection } from './components/AuthoritySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { BenefitSection } from './components/BenefitSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
// Initialize Meta Pixel once at module level (outside React lifecycle)
const PIXEL_ID = '790333870788238';
if (typeof window !== 'undefined' && !(window as any)._metaPixelLoaded) {
  ;
  (window as any)._metaPixelLoaded = true;
  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${PIXEL_ID}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
}
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <div className="w-full bg-red-600 py-2 text-center border-b-4 border-red-800" data-id="element-1">
        <span className="text-white text-sm md:text-base font-black tracking-widest animate-pulse" data-id="element-2">
          ⏳ OFERTA DISPONIBLE HOY | 🔥 ACCESO INMEDIATO AL KIT
        </span>
      </div>
      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <IncludesSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <ImageCarousel data-id="element-8" />
      <AuthoritySection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <ForWhoSection data-id="element-11" />
      <BenefitSection data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <SocialProofPopup data-id="element-14" />

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-15">
        <p data-id="element-16">
          © {new Date().getFullYear()} Aula Mater. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-17">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}